import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import ManagerDashboard from './components/manager/Dashboard.vue'
import CosLayout from "./layouts/Cos.vue"
import OnesunLayout from "./layouts/Onesun.vue"
import ManagerLayout from './layouts/Manager.vue'
import ManagerReadings from './components/manager/Readings.vue'
import ManagerPsychicProfile from './components/manager/PsychicProfile.vue'
import ManagerLogins from './components/manager/Logins.vue'
import ManagerCustomers from './components/manager/Customers.vue'
import ManagerSchedule from './components/manager/Schedule.vue'
import ManagerListings from './components/manager/Listing.vue'
import ManagerProfile from './components/manager/Profile.vue'
import ManagerSignup from "./components/manager/NewPsychic.vue"
import Psychics from './components/Psychics.vue'
import Psychic from './components/manager/Psychic.vue'
import Approvals from './components/manager/Approvals.vue'
import Statistics from './components/manager/Statistics.vue'
import PsychicLayout from './layouts/Psychic.vue'
import PsychicDashboard from './components/psychic/Dashboard.vue'
import PsychicListing from './components/psychic/Listing.vue'
import PsychicStatistics from './components/psychic/Statistics.vue'
import PsychicProfile from './components/psychic/Profile.vue'
import PsychicCustomers from './components/psychic/Customers.vue'
import PsychicSchedule from './components/psychic/Schedule.vue'
import PsychicReadings from './components/psychic/Readings.vue'
import PsychicLoginHistory from './components/psychic/LoginHistory.vue'
import Help from './components/psychic/Help.vue'
import ChatFAQ from './components/psychic/ChatFAQ.vue'
import Contact from './components/psychic/Contact.vue'
import ForgotPassword from './components/shared/ForgotPassword.vue'
import RecoverPassword from './components/shared/RecoverPassword.vue'
import ReportProblem from './components/psychic/ReportProblem.vue'
import ManagerProblem from './components/manager/ReportProblem.vue'
import Contacts from './components/manager/Contacts.vue'
import Compose from "./components/manager/Compose.vue"
import Sent from "./components/manager/SentItems.vue"
import CosHome from "./components/cos/Home.vue"
import CosApply from "./components/cos/Apply.vue"
import CosPrivacy from "./components/cos/Privacy.vue"
import OnesunHome from "./components/onesun/Home.vue"
import OnesunApply from "./components/onesun/Apply.vue"
import OnesunPrivacy from "./components/onesun/Privacy.vue"
import Login from "./components/Login.vue"

Vue.use(VueRouter)

const routes = [
  {path: '/', component: App},
  {
    name: "login",
    path: '/login', 
    component: Login,
  },
  {
    name: "forgot_password",
    path: '/forgot_password', 
    component: ForgotPassword,
  },
  {
    name: "recover_password",
    path: '/recover_password/:uuid', 
    component: RecoverPassword,
  },
  {
    name: "dashboard",
    path: '/dashboard', 
    component: ManagerDashboard, 
    meta: { layout: ManagerLayout }
  },
  {
    name: "manager_profile",
    path: '/edit_profile', 
    component: ManagerProfile, 
    meta: { layout: ManagerLayout }
  },
  {
    name: "contacts",
    path: '/contacts', 
    component: Contacts, 
    meta: { layout: ManagerLayout }
  },
  {
    name: "onesun_home",
    path: '/onesun', 
    component: OnesunHome, 
    meta: {layout: OnesunLayout, css: "/onesun.css"}
  },
  {
    name: "onesun_privacy",
    path: '/onesun/privacy', 
    component: OnesunPrivacy, 
    meta: {layout: OnesunLayout, css: "/onesun.css"}
  },
  {
    name: "onesun_apply",
    path: '/onesun/apply', 
    component: OnesunApply, 
    meta: {layout: OnesunLayout, css: "/onesun.css"}
  },
  {
    name: "cos_home",
    path: '/cos', 
    component: CosHome, 
    meta: {layout: CosLayout, css: "/cos.css"}
  },
  {
    name: "cos_apply",
    path: '/cos/apply', 
    component: CosApply, 
    meta: {layout: CosLayout, css: "/cos.css"}
  },
  {
    name: "cos_privacy",
    path: '/cos/privacy', 
    component: CosPrivacy, 
    meta: {layout: OnesunLayout, css: "/cos.css"}
  },
  {
    name: "problem",
    path: '/Problem', 
    component: ManagerProblem, 
    meta: { layout: ManagerLayout }
  },
  {
    name: "manager_signup",
    path: '/NewPsychic', 
    component: ManagerSignup, 
    meta: { layout: ManagerLayout }
  },
  {
    name: "psychics",
    path: '/psychics', 
    component: Psychics,
    meta: {layout: ManagerLayout }
  },
  {
    name: "psychic",
    path: '/psychics/:id',
    component: Psychic,
    meta: {layout: ManagerLayout}
  },
  {
    name: "compose",
    path: '/psychics/:id/compose',
    component: Compose,
    meta: {layout: ManagerLayout}
  },
  {
    name: "sent",
    path: '/psychics/:id/sent',
    component: Sent,
    meta: {layout: ManagerLayout}
  },
  {
    name: "readings",
    path: '/psychics/:id/readings',
    component: ManagerReadings,
    meta: {layout: ManagerLayout}
  },
  {
    name: "listing",
    path: '/psychics/:id/listing',
    component: ManagerListings,
    meta: {layout: ManagerLayout}
  },
  {
    name: "logins",
    path: '/psychics/:id/logins',
    component: ManagerLogins,
    meta: {layout: ManagerLayout}
  },
  {
    name: "psychic_profile",
    path: '/psychics/:id/profile',
    component: ManagerPsychicProfile,
    meta: {layout: ManagerLayout}
  },
  {
    name: "customers",
    path: '/psychics/:id/customers',
    component: ManagerCustomers,
    meta: {layout: ManagerLayout}
  },
  {
    name: "schedule",
    path: '/psychics/:id/schedule',
    component: ManagerSchedule,
    meta: {layout: ManagerLayout}
  },
  {
    name: "approvals",
    path: '/approvals', 
    component: Approvals,
    meta: {layout: ManagerLayout }
  },
  {
    name: "statistics",
    path: '/statistics', 
    component: Statistics,
    meta: {layout: ManagerLayout }
  },


  {
    name: "psychic_dashboard",
    path: "/psychic",
    component: PsychicDashboard,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_listing",
    path: "/psychic/listing",
    component: PsychicListing,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_statistics",
    path: "/psychic/statistics",
    component: PsychicStatistics,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_profile",
    path: "/psychic/profile",
    component: PsychicProfile,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_customers",
    path: "/psychic/customers",
    component: PsychicCustomers,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_schedule",
    path: "/psychic/schedule",
    component: PsychicSchedule,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_readings",
    path: "/psychic/readings",
    component: PsychicReadings,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_logins",
    path: "/psychic/logins",
    component: PsychicLoginHistory,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_help",
    path: "/psychic/help",
    component: Help,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_chatfaq",
    path: "/psychic/chat_faq",
    component: ChatFAQ,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_contact",
    path: "/psychic/contact",
    component: Contact,
    meta: {layout: PsychicLayout}
  },
  {
    name: "psychic_problem",
    path: "/psychic/problem",
    component: ReportProblem,
    meta: {layout: PsychicLayout}
  }
]


 const router = new VueRouter({
    mode: 'history',
    linkActiveClass: "is-active",
    linkExactActiveClass: "is-active",
    //base: __dirname,
    routes: routes
 })

router.beforeEach((to, from, next) => {
  if (to.fullPath === "/") {
    if (window.location.hostname.includes("circleofstars.com"))
    {
      next("/cos")
      return
    } else if (window.location.hostname.includes("onesun.com")) {
      next('/onesun')
      return
    }
  }

  if (to.matched.some(record => record.meta.css)) {
    document.getElementById("main_css").href = to.meta.css
  } else {
    document.getElementById("main_css").href = "/styles.css"
  }
  next()
})

 export default router